export class HaNewquestion {
    id:number;
    question:string;
    qTypeId:number;
    codeType:number;
    caseCodeId:string;
}
